import Vue from "vue";

import { defineStore } from "pinia";
import { postData, querySearch } from "@utils";
import { useToast } from "vue-toastification/composition";
import { ref } from "@vue/composition-api";

export const useOrderTrackingStore = defineStore("orderTracking", () => {
  const toast = useToast();

  // Ekle / Düzenle / Sil
  const viewDialogData = ref({});
  const viewDialogModel = ref(false);
  const viewDialogLoading = ref(false);
  const deleteLoading = ref(false);

  const viewDialogClose = () => {
    viewDialogModel.value = false
    viewDialogLoading.value = false;
    deleteLoading.value = false;
  };

  return {
    viewDialogData,
    viewDialogModel,
    viewDialogLoading,
    deleteLoading,
    viewDialogClose,
  };
});
